import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  withCredentials: true, // send cookie
});

// On 401 outside login, redirect to /login
client.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401 && !url.includes("/auth/")) {
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const api = {
  get: (u, cfg) => client.get(u, cfg).then(r => r.data),
  post: (u, body, cfg) => client.post(u, body, cfg).then(r => r.data),
  put: (u, body, cfg) => client.put(u, body, cfg).then(r => r.data),
  del: (u, cfg) => client.delete(u, cfg).then(r => r.data),
  // Alias — some callers use "delete" (JS keyword-safe as object property)
  delete: (u, cfg) => client.delete(u, cfg).then(r => r.data),
};
